import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'HOME_PAGE'
          }
        }, {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: 'PRODUCTS'
          },
          children: [
            {
              path: '/product',
              redirect: '/product/smartTown'
            },
            {
              path: '/product/smartTown',
              name: 'product',
              component: resolve => require(['@/view/Product_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/product/listData/:id',
              name: 'product',
              component: resolve => require(['@/view/ProductsList'], resolve),
              meta: {
                title: 'Product丨大数据管理系统'
              }
            },
            {
              path: '/product/detail',
              name: 'detail',
              component: resolve => require(['@/view/ProductDetail'], resolve),
              meta: {
                title: 'Product丨Detail'
              }
            }
          ]
        }, {
          path: '/stone',
          name: 'stone',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title:  "SERVICES"
          },
          children: [
            {
              path: '/stone/listData/:id',
              name: 'stone',
              component: resolve => require(['@/view/StonesList'], resolve),
              meta: {
                title: 'GEM STONES'
              }
            }]
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title:  "NEWS"
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title:  "ABOUT US"
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title:  "JOB CHANCE"
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title:  "CONTACT US"
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: 'SERVICES DETAIL'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js